import { useAuth } from "@/dashboard/contexts/auth-context";

// be careful where you use this, it will throw an error if the user is not logged in
export function useRequiredAuth() {
  const { user, ...rest } = useAuth();

  if (!user) {
    throw new Error("useRequiredAuth: user is unexpectedly null");
  }

  return { user, ...rest };
}
